import React from 'react';
import {
  Question,
  QuestionPayload,
} from '../../../../datasources/questions/QuestionsDataSource';
import { Basket } from '../../../../types/basket/Basket';
import { DialogQuestion } from './dialogQuestion';

type CreateQuestionDialogProps = {
  open: boolean;
  onClose: () => void;
  loading?: boolean;
  error?: string;
  questions: Question[];
  baskets: Basket[];
  basketsLoading: boolean;
  basketsError?: string;
  onConfirm: (payload: QuestionPayload) => void | Promise<void>;
};

export const CreateQuestionDialog: React.FC<CreateQuestionDialogProps> = (
  props
) => <DialogQuestion {...props} mode="create" />;
